'use client';

import { PageMain } from '@/app/(app)/page-main';

import { ServiceTypeTemplatesTable } from './table/table';

export function ServiceTypesPage() {
  return (
    <PageMain title='Service Types'>
      <ServiceTypeTemplatesTable />
    </PageMain>
  );
}
